import io, { Socket } from "socket.io-client";
import events from "config/events";
import lscache from "lscache";
import cache from "config/cache";
import { VetoState } from "context/interfaces/GameContextInterface";

class WebSocket {
  client: typeof Socket;

  constructor() {
    const player = lscache.get(cache.GamePlayer);
    const playerId = player?.id;

    this.client = io(
      process.env.REACT_APP_SOCKET_URL || "ws://localhost:4000",
      {
        transports: ["websocket"],
        query: {
          ...(playerId && { playerId }),
        },
      }
    );
  }

  watchException(callback) {
    this.client.on(events.exception, callback);
  }

  watchAuthentication(callback) {
    this.client.on(events.authentication, callback);
  }

  watchWaitingRoom(callback) {
    this.client.on(events.waitingRoom, callback);
  }

  watchBoard(callback) {
    this.client.on(events.board, callback);
  }

  watchEnd(callback) {
    this.client.on(events.end, callback);
  }

  createGame(name: string) {
    this.client.emit(events.createGame, { name });
  }

  joinGame(name: string, code: number) {
    this.client.emit(events.joinGame, { name, code });
  }

  leaveGame(code: number) {
    this.client.emit(events.leaveGame, { code });
  }

  startGame(code: number) {
    this.client.emit(events.startGame, { code });
  }

  pickChancellor(code: number, chancellorId: string) {
    this.client.emit(events.pickChancellor, { code, chancellorId });
  }

  vote(code: number, isAgree: boolean) {
    this.client.emit(events.vote, { code, isAgree });
  }

  presidentRejectRule(code: number, index: number) {
    this.client.emit(events.presidentRejectRule, { code, index });
  }

  chancellorPassRule(code: number, index: number) {
    this.client.emit(events.chancellorPassRule, { code, index });
  }

  makeAbilityDone(code: number) {
    this.client.emit(events.makeAbilityDone, { code });
  }

  killPlayer(code: number, playerId: string) {
    this.client.emit(events.killPlayer, { code, playerId });
  }

  requestVeto(code: number) {
    this.client.emit(events.requestVeto, { code });
  }

  answertVeto(code: number, answer: VetoState) {
    this.client.emit(events.answerVeto, { code, answer });
  }

  searchChoose(code: number, chosenId: string) {
    this.client.emit(events.searchChoose, { code, chosenId });
  }

  searchDone(code: number) {
    this.client.emit(events.searchDone, { code });
  }

  nextPresident(code: number, chosenId: string) {
    this.client.emit(events.nextPresident, { code, chosenId });
  }
}

export const ws = new WebSocket();
